module.exports = __webpack_public_path__ + "0b52df901f1dfcde6595c377173d921a.pdf";